'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _lodash = require('lodash');

var _workspaceSelector = require('./workspaceSelector');

var _workspaceSelector2 = _interopRequireDefault(_workspaceSelector);

var _WorkspaceContainer = require('./WorkspaceContainer');

var _WorkspaceContainer2 = _interopRequireDefault(_WorkspaceContainer);

var _RouteModalManager = require('../components/modal/RouteModalManager');

var _RouteModalManager2 = _interopRequireDefault(_RouteModalManager);

var _GridSizeManager = require('../utils/grid/GridSizeManager');

var _GridSizeManager2 = _interopRequireDefault(_GridSizeManager);

var _workspaceUserFetchDecorator = require('./decorators/workspaceUserFetchDecorator');

var _workspaceUserFetchDecorator2 = _interopRequireDefault(_workspaceUserFetchDecorator);

var _workspaceRootRedirectionDecorator = require('./decorators/workspaceRootRedirectionDecorator');

var _workspaceRootRedirectionDecorator2 = _interopRequireDefault(_workspaceRootRedirectionDecorator);

var _workspaceArtificialLoadingDelayDecorator = require('./decorators/workspaceArtificialLoadingDelayDecorator');

var _workspaceArtificialLoadingDelayDecorator2 = _interopRequireDefault(_workspaceArtificialLoadingDelayDecorator);

var _workspaceBoardFetchDecorator = require('./decorators/workspaceBoardFetchDecorator');

var _workspaceBoardFetchDecorator2 = _interopRequireDefault(_workspaceBoardFetchDecorator);

var _workspaceNavigationDecorator = require('./decorators/workspaceNavigationDecorator');

var _workspaceNavigationDecorator2 = _interopRequireDefault(_workspaceNavigationDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* ----
 * WorkspaceInitContainer
 * This component is the top level of the workspace stack,
 * it's responsible for fetching data and displaying and route-based modals
 */

// the decorators responsible for board data should only
// be used after the user is ititialised


// Components
var boardLoadManagerEnhance = (0, _recompose.branch)(function (_ref) {
    var isUserAvailable = _ref.isUserAvailable;
    return !!isUserAvailable;
}, (0, _recompose.compose)(_workspaceBoardFetchDecorator2.default, _workspaceNavigationDecorator2.default), _lodash.identity);

// this handles loading of board and user navigation
// using conditional decorators that only attach once


// Selectors
var BoardLoadManager = boardLoadManagerEnhance(function () {
    return null;
});

var workspaceInitEnhance = (0, _recompose.compose)(
// select all data needed by the workspace
(0, _reactRedux.connect)(_workspaceSelector2.default),
// keep the loader around until everything is ready to show
_workspaceArtificialLoadingDelayDecorator2.default,
// redirect '/' route to '/ROOT_BOARD_ID' route
_workspaceRootRedirectionDecorator2.default,
// fetch user data
_workspaceUserFetchDecorator2.default);

var WorkspaceInitContainer = function WorkspaceInitContainer(props) {
    var children = props.children;


    return _react2.default.createElement(
        _GridSizeManager2.default,
        null,
        _react2.default.createElement(
            'div',
            { className: 'WorkspaceInitContainer' },
            _react2.default.createElement(BoardLoadManager, props),
            _react2.default.createElement(_WorkspaceContainer2.default, props),
            _react2.default.createElement(
                _RouteModalManager2.default,
                null,
                children
            )
        )
    );
};

WorkspaceInitContainer.propTypes = {
    currentBoardId: _propTypes2.default.string,
    isGuest: _propTypes2.default.bool,
    isUserAvailable: _propTypes2.default.bool,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
    location: _propTypes2.default.object
};

exports.default = workspaceInitEnhance(WorkspaceInitContainer);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/WorkspaceInitContainer.js
// module id = 2152
// module chunks = 0